import BioSearch from "./BioSearch";
export default BioSearch;